import { useState } from 'react';

import _uniqueId from 'lodash/uniqueId';
import { SyntheticEvent } from 'react';
import { useEffect } from 'react';

type CheckboxProps = {
  label?: string;
  isChecked?: boolean;
  className?: string;
  onChange?: (checked: boolean) => void;
};

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  isChecked = false,
  className,
  onChange,
}) => {
  const [checked, setChecked] = useState(isChecked);
  const [checkboxId] = useState(_uniqueId('checkbox-'));

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const newState = e.currentTarget.checked;
    setChecked(newState);
    onChange && onChange(newState);
  };

  return (
    <div className={`flex w-full items-center justify-start ${className}`}>
      <input
        className="display-grid relative bottom-[1px] h-[0.75rem] w-[0.75rem] cursor-pointer appearance-none place-items-center border border-madriwaGreen transition-all duration-200 ease-out checked:border-madriwaGreen checked:bg-madriwaGreen disabled:pointer-events-none disabled:cursor-default disabled:opacity-50"
        type="checkbox"
        name=""
        id={checkboxId}
        onChange={handleChange}
        checked={checked}
      />
      {label && (
        <label
          className="flex cursor-pointer px-[0.5rem] font-[0.75rem] capitalize"
          htmlFor={checkboxId}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
